//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReportRemarkImportantCheckbox from './ReportRemarkImportantCheckbox.vue'

export default {
  components: {
    ReportRemarkImportantCheckbox
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    remarks: {
      type: Array,
      default: function () {
        return []
      }
    },
    imagesRemarks: {
      type: Array,
      default: function () {
        return []
      }
    },
    categories: {
      type: Array,
      default: function () {
        return []
      }
    },
    file: {
      type: Object,
      default: function () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default: function () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    onRemove: function (remark, action) {
      const reportImagesRemark = this.imagesRemarks.find(r => r.code === remark.code && r.comment === remark.comment && r.active)
      if (reportImagesRemark != null) {
        if (action === 'noRemark') {
          reportImagesRemark.active = false
        } else if (action === 'noFile') {
          reportImagesRemark.documentsIds = reportImagesRemark.documentsIds.filter(docId => docId !== this.file.document.id)
        }
        const file = this.categories.find(c => c.categoryKey === this.file.document.category).files.find(f => f.document.id === this.file.document.id)
        if (file) {
          file.remarks = file.remarks.filter(r => r.code !== remark.code || r.comment !== remark.comment)
        }
      }
      this.$emit('remark-changed')
      this.$emit('close')
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

